import type { MaturityTimelineBlock as Block } from './types'
import { BlockShell } from './BlockShell'
import { MaturityTimeline } from '../../charts/MaturityTimeline'
import type { BlockAction } from './BlockActionsMenu'
import type { MaturityItem } from '../../../contracts'

interface Props {
  block: Block
  selected: boolean
  frozen: boolean
  animate: boolean
  actions: BlockAction[]
  onToggleSelect: (id: string) => void
}

export function MaturityTimelineBlockView({ block, ...rest }: Props) {
  const items = block.items.map((item) => ({
    label: item.label,
    date: item.date,
    amount: item.amount ?? 0,
  })) satisfies MaturityItem[]
  return (
    <BlockShell blockId={block.id} slug={block.slug} {...rest}>
      <MaturityTimeline items={items} />
    </BlockShell>
  )
}
